export const TAGS = {
  RECENTLY_ANSWERED: "recently-answered",
  INTERVIEW_PREPRATION: "interview-prepration",
  INTERVIEW_ANSWER: "interview-answer",
};
